export type Day = {
  n: number;
  title: string;
};

// Positional map to Firestore calendar/humanities chronological days:
// DAYS[0] is the first day of Week 1, DAYS[9] is the last day of Week 2.
// Titles are drafts from schedule.csv concepts — edit freely.
export const DAYS: Day[] = [
  { n: 1,  title: "First Programs" },
  { n: 2,  title: "Strings, Lists & Loops" },
  { n: 3,  title: "Functions & Dictionaries" },
  { n: 4,  title: "Files & JSON" },
  { n: 5,  title: "AI & Pandas" },
  { n: 6,  title: "Pandas & matplotlib" },
  { n: 7,  title: "Building with AI" },
  { n: 8,  title: "APIs & NumPy" },
  { n: 9,  title: "GitHub, Classes, & Notebooks" },
  { n: 10, title: "Web Scraping with Selenium" },
];
